import {ordersConstants} from '../constants/orders.constants';

export function Orders(state = {}, action) {
  switch (action.type) {
    case ordersConstants.ORDERS_LOAD_DATA_REQUEST:
      return {
        loading: true
      };
    case ordersConstants.ORDERS_LOAD_DATA_SUCCESS:
      return {
        ...state,
        ...state.orders,
        data: action.data
      };
    case ordersConstants.ORDERS_LOAD_DATA_FAILURE:
      return {
        error: action.error
      };

    case ordersConstants.ORDERS_LOAD_DETAIL_SUCCESS:
      return {
        ...state,
        ...state.orders,
        detail: action.detail
      };
    case ordersConstants.ORDERS_LOAD_DETAIL_FAILURE:
      return {
        error: action.error
      };

    case ordersConstants.ORDERS_RESET_DETAIL_SUCCESS:
      return {
        ...state,
        ...state.orders,
        detail: action.detail
      };

    case ordersConstants.ORDERS_ADD_TO_SELECTED:
      let count = state.selected && state.selected.length;
      //state && state.selected && action.item ? state.selected.filter(item => item.id === action.item.id) : [];
      if (count === 0) {
        return {
          ...state,
          ...state.orders,
          selected: state && state.selected ? [...state.selected, action.item] : [action.item]
        };
      } else {
        return {
          ...state,
          ...state.orders,
          ...state.selected
        };
      }

    case ordersConstants.ORDERS_SET_SUBMENU:
      return {
        ...state,
        ...state.orders,
        submenu: action.submenu
      };

    case ordersConstants.ORDERS_SET_DETAIL_ID:
      return {
        ...state,
        ...state.orders,
        detailId: action.detailId
      };

    case ordersConstants.ORDERS_SAVE_DATA_SUCCESS:
      return {
        ...state,
        ...state.orders,
        isSubmitting: action.isSubmitting
      };
    default:
      return state
  }
}